import { Directive, Input } from '@angular/core';

// libs

@Directive()
export abstract class LabelBaseComponent {
  @Input() text?: string | null;
  @Input() className?: string;
  @Input() hyphen?: boolean = true;
}
